var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 748,
    height: 550,
    viewBox: "0 0 748 550",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_82_33)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M395.638 386.172C473.185 381.07 523.798 352.445 573.026 285.846C672.755 150.929 90.0808 108.07 171.228 256.292C222.393 349.749 296.586 392.689 395.638 386.172Z",
    fill: "#E02EF0",
    fillOpacity: 0.23
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_82_33",
    x: 0.354218,
    y: 0.0870056,
    width: 747.289,
    height: 549.823,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 81.547,
    result: "effect1_foregroundBlur_82_33"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPink);
export default __webpack_public_path__ + "static/media/pink.86fb5e2ad1e08ac41ddcf7cb5b0e3450.svg";
export { ForwardRef as ReactComponent };